import { K8sProvider } from '@cast/shared-types';
import {
  AgentStatus,
  Cluster,
  ClusterDisplayStatus,
  ClusterStatus,
} from '@cast/types';

import { isClusterManaged } from '@cast/shared-cluster-context-data-access';

// prettier-ignore
export const useGetClusterActionsVisibility = (cluster: Cluster) => {
  const isFailed = Boolean(cluster.reconcileError);
  const isNotFound = cluster.displayStatus === ClusterDisplayStatus.NOT_FOUND;
  const isManaged = isClusterManaged(cluster);
  const isHibernated = cluster.status === ClusterStatus.HIBERNATED;
  const isOnline = cluster.agentStatus === AgentStatus.ONLINE;
  const isReady = cluster.status === ClusterStatus.READY;
  const isDisconnected = cluster.agentStatus === AgentStatus.DISCONNECTED;
  const isConnecting = cluster.status === ClusterStatus.CONNECTING || cluster.agentStatus === AgentStatus.CONNECTING;
  const isCastAnywhere = cluster.providerType === K8sProvider.ANYWHERE;

  return {
    hibernate: isOnline && isReady && isManaged && !isCastAnywhere && !isHibernated,
    resume: !isFailed && isHibernated,
    disconnect: !isFailed && !isNotFound && ((isManaged && !isDisconnected) || isOnline),
    delete: !isCastAnywhere && ((!isFailed && !isNotFound && isDisconnected) || isConnecting),
    reconnect: !isReady && !isCastAnywhere && !isNotFound && (isManaged || isDisconnected || isFailed),
    reconcile: isManaged && !isCastAnywhere && !isDisconnected,
    remove: isFailed || isNotFound || (isDisconnected && isCastAnywhere),
    adjustCosts: isCastAnywhere,
    features: !isCastAnywhere && (isManaged ? isReady : isOnline),
  };
};
